import landTiers from 'pools/finished/polkafantasy/images/landTiers.jpeg';
import landTiles from 'pools/finished/polkafantasy/images/landTiles.jpeg';
import landTypes from 'pools/finished/polkafantasy/images/landTypes.jpeg';
import landUtilities from 'pools/finished/polkafantasy/images/landUtilities.jpeg';
import metaImg from 'pools/finished/polkafantasy/images/metaImg.jpeg';
import tokenImg from 'pools/finished/polkafantasy/images/polkaFantasy.jpg';

export { tokenImg, metaImg, landTiers, landTypes, landTiles, landUtilities };
